import React from 'react';
import Layout from '../components/Layout';

const Analytics = () => {
  return (
    <Layout>
      <div className="p-8">
        <h1 className="text-4xl font-bold text-slate-900 font-manrope" data-testid="analytics-title">Analytics & Reports</h1>
        <p className="text-slate-600 mt-1">Performance metrics and insights</p>
        <div className="mt-8 bg-white rounded-lg border border-slate-200 p-8 text-center">
          <p className="text-slate-500">Detailed analytics and reports - Coming in Phase 2</p>
        </div>
      </div>
    </Layout>
  );
};

export default Analytics;
